var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTroubles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#ec7b47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-255 347 100 100",
    enableBackground: "new -255 347 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-205,367c16.569,0,30,13.431,30,30s-13.431,30-30,30s-30-13.431-30-30S-221.569,367-205,367 M-205,362   c-19.299,0-35,15.701-35,35s15.701,35,35,35s35-15.701,35-35S-185.701,362-205,362L-205,362z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-205,406.999c2.891,0,5.695,0.847,8.081,2.375c-2.659-0.208-5.361-0.313-8.081-0.313   s-5.422,0.105-8.081,0.313C-210.694,407.847-207.891,406.999-205,406.999 M-205,401.999c-6.628,0-12.502,3.227-16.136,8.196   c-1.494,2.043-0.012,4.806,2.39,4.806c0.147,0,0.298-0.01,0.452-0.032c4.198-0.59,8.663-0.908,13.295-0.908   s9.097,0.318,13.295,0.908c0.154,0.022,0.305,0.032,0.452,0.032c2.402,0,3.884-2.763,2.39-4.806   C-192.498,405.227-198.372,401.999-205,401.999L-205,401.999z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: -193.002,
    cy: 390.999,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -216.998,
    cy: 390.999,
    r: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTroubles);
export default __webpack_public_path__ + "static/media/troubles.f85af9ebbf1f7c5acd0383446f3c96cc.svg";
export { ForwardRef as ReactComponent };